import React, { useMemo } from 'react';

import type { Event } from '@vlabs/api/luna-api/model/Event';

import { EventCard } from '@vlabs/monokit/shared/ui/event-card/';

import type { Face } from './types';
import { useSearch } from '../../search-provider/SearchProvider';

type SearchResultCardProps =
  | {
    data: Face & { similarity: number };
    eventCard?: typeof EventCard;
  }
  | {
    data: Event & { similarity: number };
    eventCard?: typeof EventCard;
  };

function SearchResultCard({
  data,
  eventCard: EventCardComponent = EventCard,
}: SearchResultCardProps): JSX.Element {
  const { candidateOrigin, matcherType } = useSearch();
  const { similarity } = data;

  const cardContent = useMemo(() => {
    switch (candidateOrigin) {
      case 'events': {
        if (!data.event_id) return null;

        return (
          <EventCardComponent
            eventId={data.event_id}
            matcherType={matcherType}
            similarity={similarity}
          />
        );
      }
      case 'faces': {
        if (!data.face_id) return null;

        return (
          <EventCardComponent
            faceId={data.face_id}
            similarity={similarity}
            type="face"
          />
        );
      }
      default:
        return null;
    }
  }, [data, candidateOrigin, similarity, matcherType, EventCardComponent]);

  return (
    <React.Fragment>
      {cardContent}
    </React.Fragment>
  );
}

export { SearchResultCard };
